import { createSlice } from '@reduxjs/toolkit';
import axios from 'utils/axios';

const initialState = {
    loading: false,
    totalUsers: 0,
    totalPages: 1,
    page: 1,
    list: []
};

// ==============================|| SLICE - Users ||============================== //

const usersSlice = createSlice({
    name: 'users',
    initialState,
    reducers: {
        loadingSetter(state, action) {
            state.loading = action.payload
        },
        usersSetter(state, action) {
            const { list, page, totalUsers, totalPages } = action.payload;
            state.totalUsers = totalUsers
            state.totalPages = totalPages
            state.page = page
            state.list = list
        }
    }
});

const { loadingSetter, usersSetter } = usersSlice.actions;

const getUsers = (params) => async dispatch => {
    try {
        dispatch(loadingSetter(true));
        const response = await axios.get("/api/users/get", { params })
        dispatch(usersSetter(response.data));
        dispatch(loadingSetter(false));
    } catch (error) {
        dispatch(loadingSetter(false));
        console.log(error);
    }

}

export {
    getUsers,
    loadingSetter
}

export default usersSlice.reducer;
